// @flow

import { compose } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import type { ApplicationState } from "../../reducers";
import GridElement from "../../components/gridPages/GridElement";
import {RoleTypes} from "../../models/Role";

function mapStateToProps(state: ApplicationState, _ownProps) {
	const needsPickupLocation = state.config.garageGroupId && !state.location.pickupLocation && !state.config.productPricesDisabled;
	return {
		showPrice: !state.config.productPricesDisabled,
		needsPickupLocation,
        showMSRP: state.config.showMsrp,
        isNSCDealer: state.config.role === RoleTypes.DISTRIBUTOR,
	};
}

function mapDispatchToProps(_dispatch, _ownProps) {
	return {

	};
}

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(GridElement);
